import React from "react";
import { Col, Row } from "react-bootstrap";
import Security from "../../Assets/TechIcons/Sec.svg";
import Network from "../../Assets/TechIcons/Net.svg";
import Linux from "../../Assets/TechIcons/Lin.svg";

function Certifications() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={4} md={2} className="cert-icons ">
        <img src={Network} alt="Network+" className="cert-icon-images" />

      </Col>

      <Col xs={4} md={2} className="cert-icons ">
        <img src={Security} alt="Security+" className="cert-icon-images" />

      </Col>

      <Col xs={4} md={2} className="cert-icons ">
        <img src={Linux} alt="Linux+" className="cert-icon-images" />

      </Col>

    </Row>
  );
}

export default Certifications;
